import React from 'react';
import { Link } from 'react-router-dom';

const ProductsCTA = () => {
  // Background image path - easily customizable
  const backgroundImage = '/images/hero-background3.jpeg';

  return (
    <>
      {/* Get Started Section */}

      {/* Need Help Section */}
      <section 
        className="relative bg-cover bg-center bg-no-repeat text-white py-16"
        style={{
          backgroundImage: `url(${backgroundImage})`
        }}
      >
        {/* Blue gradient overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-br from-catalina-blue/90 to-san-marino/90"></div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Need Help Choosing?</h2>
          <p className="text-lg mb-8 text-gray-200 max-w-2xl mx-auto">
            Our experts are ready to help you find the perfect solution for your needs
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link
              to="/contact"
              className="inline-block bg-white text-catalina-blue px-8 py-3 rounded-lg text-lg font-semibold hover:bg-gray-100 transition duration-300"
            >
              Contact Our Team
            </Link>
            <Link
              to="/about"
              className="inline-block bg-transparent border-2 border-white text-white px-8 py-3 rounded-lg text-lg font-semibold hover:bg-white hover:text-catalina-blue transition duration-300"
            >
              Learn More About Us
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProductsCTA;